import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

const CustomImageSwiper = ({ dataList }) => {
  return (
    <Swiper
      direction={"horizontal"}
      slidesPerView={1}
      spaceBetween={0}
      pagination={{ clickable: true }}
      modules={[Pagination]}
      loop={true}
      className="fog_custom_swiper_container"
    >
      {Array.isArray(dataList) && dataList?.length > 0
        ? dataList.map((slideImage, index) => (
            <SwiperSlide key={index}>
              <img
                src={
                  slideImage?.base64 && slideImage?.base64?.includes("base64")
                    ? slideImage?.base64
                    : process.env.REACT_APP_IMAGE_URL +
                      (slideImage?.image_url || slideImage?.image)
                }
                className="photo-details-img"
                alt="product details"
              />
            </SwiperSlide>
          ))
        : null}
    </Swiper>
  );
};

export default CustomImageSwiper;
